import { inject, Service } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import localforage from "localforage";

import { environment } from "../../core/environments/environment";
import { Constants } from "../constants/constants";
import { UserLoginStorage } from "../models";
import { LoginService } from "./login-service";

@Service()
export class LogoutService {
  //NOTE: Don't Use AppService it will break the service
  private _loginService = inject(LoginService);
  private _modalService = inject(NgbModal);

  private _unRemovableStorageItem = [
    Constants.localStorageKeys.lastUrlVisited,
    Constants.localStorageKeys.language,
    Constants.localStorageKeys.hardwareUuid,
    Constants.localStorageKeys.systemTour,
    Constants.localStorageKeys.sessionExpired,
    Constants.localStorageKeys.theme,
  ];
  private _unRemovableStorageValues: UserLoginStorage[] = [];

  public logout(skipBERequest: boolean = false): void {
    // Close all active modals
    this._modalService.dismissAll();

    if (skipBERequest) {
      const isUaePassLogin = localStorage.getItem(Constants.localStorageKeys.uaePassLogin) === "true";
      this._successLogout(isUaePassLogin);
    } else
      this._loginService.logout().subscribe((response) => {
        if (response.inError) return;

        const isUaePassLogin = localStorage.getItem(Constants.localStorageKeys.uaePassLogin) === "true";
        this._successLogout(isUaePassLogin);
      });
  }

  private _successLogout(isUaePassLogin: boolean): void {
    this._unRemovableStorageItem.forEach((item) => {
      this._unRemovableStorageValues.push({
        key: item,
        value: localStorage.getItem(item),
      });
    });

    localStorage.clear();
    localforage.clear();

    this._unRemovableStorageValues.forEach((storage: UserLoginStorage) => {
      if (storage.value) {
        localStorage.setItem(storage.key, storage.value);
      }
    });

    if (isUaePassLogin) {
      const url = `${environment.uaePass.logoutUrl}/?redirect_uri=${environment.uaePass.loginUrl}`;
      window.location.href = url;
    } else {
      window.location.replace("/login");
    }
  }
}
